import React from 'react';

const PDF_ICON = "<svg viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"currentColor\" d=\"m0 64c0-35.3 28.7-64 64-64h160v128c0 17.7 14.3 32 32 32h128v144h-208c-35.3 0-64 28.7-64 64v144h-48c-35.3 0-64-28.7-64-64z\" opacity=\".4\"></path><path fill=\"currentColor\" d=\"m384 160-160-160v128c0 17.7 14.3 32 32 32zm-208 192c-8.8 0-16 7.2-16 16v80 48c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h16c30.9 0 56-25.1 56-56s-25.1-56-56-56zm32 80h-16v-48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48zm32 128h-16v-96h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16zm80-112v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16z\"></path></svg>";
const ZIP_ICON = "<svg class=\"svg-inline--fa fa-file-zipper\" data-prefix=\"fad\" data-icon=\"file-zipper\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\" data-fa-i2svg=\"\"><g class=\"fa-duotone-group\"><path class=\"fa-secondary\" fill=\"currentColor\" d=\"M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 352.3c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8l-14.8 0c-14.5 0-27.2 9.7-30.9 23.8L66.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4zM96 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z\"></path><path class=\"fa-primary\" fill=\"currentColor\" d=\"M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM96 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-6.3 71.8L66.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8l-14.8 0c-14.5 0-27.2 9.7-30.9 23.8zM112 336l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z\"></path></g></svg>";
const STP_ICON = "<svg class=\"svg-inline--fa fa-cubes\" data-prefix=\"fad\" data-icon=\"cubes\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\" data-fa-i2svg=\"\"><g class=\"fa-duotone-group\"><path class=\"fa-secondary\" fill=\"currentColor\" d=\"M48 323.2l80 30.6 0 100.4L52.8 421.2c-2.9-1.3-4.8-4.2-4.8-7.3l0-90.7zm128 30.6l80-30.6 0 95.9-80 35.2 0-100.4zM184 121c26.7 10.2 53.3 20.4 80 30.7l0 89.2c-26.7-10.1-53.3-20.2-80-30.3l0-89.6zm128 30.7c26.7-10.2 53.3-20.4 80-30.7l0 89.6c-26.7 10.1-53.3 20.2-80 30.3l0-89.2zm8 171.6l80 30.6 0 100.4-80-35.2 0-95.9zm128 30.6l80-30.6 0 90.7c0 3.2-1.9 6-4.8 7.3L448 454.3l0-100.4z\"></path><path class=\"fa-primary\" fill=\"currentColor\" d=\"M290.8 48.6c-1.8-.7-3.8-.7-5.7 0L206.8 78.3 288 109.5l81.2-31.1L290.8 48.6zM184 210.6l80 30.3 0-89.2L184 121l0 89.6zm128 30.3l80-30.3 0-89.6-80 30.7 0 89.2zM288 457.5L174.5 507.3c-14.4 6.3-30.7 6.3-45.1 0l-96-42.2C13.1 456.2 0 436.1 0 413.9L0 294.7c0-23.3 14.4-44.1 36.1-52.4l96-36.4c1.3-.5 2.6-.9 3.9-1.3l0-112.2c0-23.3 14.4-44.1 36.1-52.4l96-36.4c12.8-4.8 26.9-4.8 39.7 0l96 36.4C425.6 48.4 440 69.3 440 92.5l0 112.2c1.3 .4 2.6 .8 3.9 1.3l96 36.4c21.8 8.2 36.1 29.1 36.1 52.4l0 119.1c0 22.2-13.1 42.3-33.5 51.3l-96 42.2c-14.4 6.3-30.7 6.3-45.1 0L288 457.5zM149.2 250.9L70.8 280.6 152 311.7l81.2-31.1-78.4-29.7c-1.8-.7-3.8-.7-5.7 0zm26.8 103l0 100.4 80-35.2 0-95.9-80 30.6zm-48 0L48 323.2l0 90.7c0 3.2 1.9 6 4.8 7.3L128 454.3l0-100.4zm293.2-103l-78.4 29.7L424 311.7l81.2-31.1-78.4-29.7c-1.8-.7-3.8-.7-5.7 0zM448 454.3l75.2-33.1c2.9-1.3 4.8-4.2 4.8-7.3l0-90.7-80 30.6 0 100.4zM400 353.9l-80-30.6 0 95.9 80 35.2 0-100.4z\"></path></g></svg>";
const DOC_ICON = "<svg class=\"svg-inline--fa fa-file-word\" data-prefix=\"fad\" data-icon=\"file-word\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\" data-fa-i2svg=\"\"><g class=\"fa-duotone-group\"><path class=\"fa-secondary\" fill=\"currentColor\" d=\"M0 64C0 28.7 28.7 0 64 0L224 0c0 42.7 0 85.3 0 128c0 1.1 0 1.4 0 1.7c0 .5 .1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 264c0-.6 0-.3 0 0z\"></path><path class=\"fa-primary\" fill=\"currentColor\" d=\"M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM111 257.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10 12 16.9 22.4 17.1s19.8-6.2 23.2-16.1L192 336.6l33.3 95.3c3.4 9.8 12.8 16.3 23.2 16.1s19.5-7.1 22.4-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-26.8 89.2-31.6-90.3c-3.4-9.6-12.5-16.1-22.7-16.1s-19.3 6.4-22.7 16.1l-31.6 90.3L111 257.1z\"></path></g></svg>";

const FILE_ICONS = {
  pdf: PDF_ICON,
  zip: ZIP_ICON,
  stp: STP_ICON,
  doc: DOC_ICON,
  docx: DOC_ICON,
};

const getFileExtension = (url) => {
  if (!url) return '';
  const cleanUrl = url.split('#')[0].split('?')[0];
  const parts = cleanUrl.split('.');
  if (parts.length < 2) return '';
  return parts.pop().toLowerCase();
};

const decodeHtmlEntities = (value) => {
  if (!value) return value;
  const doc = new DOMParser().parseFromString(value, 'text/html');
  return doc.documentElement.textContent || value;
};

const getIconMarkup = (extension) => {
  return FILE_ICONS[extension] || null;
};

const ResourceLink = ({ file, label }) => {
  if (!file?.url) return null;
  const iconMarkup = getIconMarkup(file.extension);
  return (
    <a href={file.url} target="_blank" rel="noopener noreferrer">
      {iconMarkup && (
        <span
          className="component-resource__icon"
          aria-hidden="true"
          dangerouslySetInnerHTML={{ __html: iconMarkup }}
        />
      )}
      <span className="component-resource__label">{decodeHtmlEntities(label || file.title)}</span>
    </a>
  );
};

const ResourceList = ({ categories }) => {
  const categoryEntries = Object.entries(categories || {}).sort(([, left], [, right]) => {
    const leftOrder = typeof left?.order === 'number' ? left.order : 0;
    const rightOrder = typeof right?.order === 'number' ? right.order : 0;
    return leftOrder - rightOrder;
  });

  return (
    <div className="component-resource-categories">
      {categoryEntries.map(([categoryKey, category]) => (
        <details className="component-resource-category" key={categoryKey}>
          <summary className="component-resource-category__title">
            {decodeHtmlEntities(category.name)}
          </summary>
          <div className="component-resource-category__content">
            {Object.keys(category.resources || {}).map((resourceKey) => {
              const resource = category.resources[resourceKey];
              if (!resource?.files?.length) {
                return null;
              }

              if (resource.files.length === 1) {
                const file = resource.files[0];
                return (
                  <div className="component-resource" key={resourceKey}>
                    <ResourceLink file={file} />
                  </div>
                );
              }

              const combinedPdf = resource.combined_pdf;
              return (
                <div className="component-resource" key={resourceKey}>
                  {combinedPdf ? (
                    <ResourceLink
                      file={combinedPdf}
                      label={`${decodeHtmlEntities(resource.title)} - Combined Datasheet & References`}
                    />
                  ) : (
                    <span className="component-resource__title">
                      {decodeHtmlEntities(resource.title)}
                    </span>
                  )}
                  <ul className="component-resource__list">
                    {resource.files.map((file) => (
                      <li key={file.id || file.url}>
                        <ResourceLink file={file} />
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </details>
      ))}
       <a target="_blank" href="/products/power-modules/technical-abbreviations" className="technical-abbreviations">Technical Abbreviations</a>
    </div>
  );
};

export default ResourceList;
